module.exports = __webpack_public_path__ + "img/kpys.bcabc111.png";